/**
 * 自动回复页面（占位）
 */
export default function AutoReplyPage() {
  return (
    <div className="h-full flex items-center justify-center text-muted-foreground">
      <div className="text-center">
        <h2 className="text-lg font-medium mb-2">自动回复</h2>
        <p className="text-sm">功能开发中，敬请期待</p>
      </div>
    </div>
  );
}
